import React, { useEffect, useState } from 'react';
import './App.css';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { finishLoadingUser } from "./redux/slices/userLoadingSlice";
import { setUser } from "./redux/slices/userSlice";
import { getAllCategories, getCurrentUser } from './Services/AdminServices';
import UserRoutePages from './Routes/UserRoutes';
import NavBar from './User/Components/Navbar/NavBar';
import TabNavigation from './User/Components/Navbar/TabNavigation';
import ResponsiveDrawer from './Admin/Component/Drawer/Drawer';
import Footer from './User/Components/Footer/Footer';
import { premiumAdds } from './Services/UserServices';
import { useNavigate } from 'react-router-dom';

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [premiumAds, setPremiumAds] = useState([]);
  const [premiumAdsLoading, setPremiumAdsLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("authtoken")) {
      getCurrentUser().then((response) => {
        dispatch(setUser(response?.data));
        dispatch(finishLoadingUser());
        // Redirect only if the user is not already on an admin page
        if (location.pathname === "/login" || location.pathname === "/") {
          navigate("/admin/dashboard");
        }
      })
        .catch((err) => {
          localStorage.removeItem("authtoken");
          dispatch(finishLoadingUser());
        });
    } else {
      dispatch(finishLoadingUser());
    }
  }, [dispatch]);

  useEffect(() => {
    const handleContextMenu = (e) => {

      // Allow right-click / long-press in React Quill editor, input fields, and textareas
      if (
        e.target.closest(".ql-editor") ||  // Allow React Quill
        ["INPUT", "TEXTAREA"].includes(e.target.tagName) ||  // Allow input fields
        e.target.isContentEditable // Allow editable elements (like div[contenteditable])
      ) {
        return;
      }

      // Block right-click everywhere else
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);


  const getCategories = async () => {
    try {
      setPremiumAdsLoading(true);
      await getAllCategories().then((res) => {
        let response = res?.data?.categories;
        if (response) {
          setCategories(response);
        }
      })

      await premiumAdds().then((res) => {
        let data = res?.data?.ads;
        if (data) {
          setPremiumAds(data);
        }
      })
    } catch (err) {
      console.log(err);
    } finally {
      setPremiumAdsLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  if (location.pathname.includes("/admin")) {
    return (
      <div className="App">
        <ResponsiveDrawer categories={categories} setCategories={setCategories} />
      </div>
    );
  }

  return (
    <div className="App">
      <div className="body-center">
        <div className="body-width">
          <NavBar />
          <TabNavigation categories={categories} premiumAds={premiumAds} premiumAdsLoading={premiumAdsLoading} />
          <UserRoutePages />
          <div style={{ paddingTop: 30 }}>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
